import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteMeetingPayload {
    meetingId: string
}

export interface IDeleteMeetingState {
    status: string
    data: any
    errors: any
}

const initialState: IDeleteMeetingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteMeeting = createSlice({
    name: 'meeting/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteMeetingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteMeetingActions = deleteMeeting.actions
export default deleteMeeting.reducer
